import type { Resolver } from 'cpool-schemas';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

import { UserGroupContextZod, UsersTableDefinitionZod } from '../tables';

type Arguments = {
    position?: number;
};

export const schemaUserResolver_List = z.array(
    UsersTableDefinitionZod.pick({
        assignable: true,
        avatar: true,
        certFileName: true,
        deactivated: true,
        delegateId: true,
        email: true,
        europacePlatforms: true,
        firstName: true,
        gender: true,
        id: true,
        lastName: true,
        organization: true,
        ownedBuckets: true,
        phone: true,
        pid: true,
        procheckId: true,
        registered: true,
        role: true,
        signatureId: true,
        smtp: true,
        teamId: true,
        title: true,
    })
        .merge(UserGroupContextZod)
        .merge(
            z.object({
                ledTeamId: schemaId.optional(),
                locked: z.boolean().optional(),
                teamLeaderId: schemaId.optional(),
            }),
        ),
);

export type SchemaUserResolver_List = z.infer<typeof schemaUserResolver_List>;

export type UserResolver_List = Resolver<Arguments, SchemaUserResolver_List>;
